.root {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 6px 0;
  font-size: 13px;
}
.list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 5px 10px;
  border: 0;
  background: transparent;
  text-align: left;
  color: var(--ink);
  font: inherit;
}
.row:hover {
  background: var(--hover-bg);
}
.row[data-selected='true'] {
  background: var(--focus-soft);
}
.icon {
  width: 14px;
  color: var(--ink-faint);
}
.name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.meta {
  color: var(--ink-faint);
  font-family: var(--font-mono);
  font-size: 11px;
}
.empty {
  margin: 0;
  padding: 16px;
  color: var(--ink-faint);
  font-style: italic;
}
